import { FC } from "react";
import styles from "./FooterPage.module.scss";

export const Impressum: FC = () => {
  return (
    <div className={styles.infomation}>
      <div className={styles.infomation_conteiner}>
        <h2 className={styles.infomation__subtitle}>Impressum</h2>
        <h1 className={styles.infomation__title}>Impressum</h1>
      </div>
      <h3 className={styles.infomation_header}>HYPE GROW, UNIPESSOAL LDA</h3>
      <p className={styles.infomation_text}>Centro Empresarial Arquiparque,</p>
      <p className={styles.infomation_text}>
        Rua Dr. António Loureiro Borges, nº1, 2º Piso,
      </p>
      <p className={styles.infomation_text}>
        1495-131 Algés, distrito de Lisboa, concelho de Oeiras, freguesia de
        Algés, Linda-a-Velha e Cruz Quebrada-Dafundo,
      </p>
      <p className={styles.infomation_text}>PORTUGAL</p>
      <p className={styles.infomation_text}>Leonardo Schneider</p>
      <p className={styles.infomation_text}>Número fiscal: PT517162989</p>
      <h3 className={styles.infomation_header}>
        Jugendschutzbeauftragter gemäß § 7 JMStV
      </h3>
      <p className={styles.infomation_text}>Rechtsanwalt</p>
      <p className={styles.infomation_text}>Jochen Jüngst</p>
      <p className={styles.infomation_text}>Schimmelmannstraße 64</p>
      <p className={styles.infomation_text}>22143 Hamburg</p>
      <p className={styles.infomation_text}>+494087408606</p>
    </div>
  );
};
